module.exports = __webpack_public_path__ + "img/1200w户外.d366cb93.png";